<template>
  <section class="comp-commodity">
    <div
      v-for="(redpacket, index) in commiditys"
      :key="index"
      @click="throttleClick(redpacket, index)"
    >
      <img width="100%" :src="picHost+redpacket.imgLink[redpacket.status]">
    </div>
  </section>
</template>
<script>
import { throttle } from '@/utils/q_business'
/**
 * 红包的ui组件
*/
export default {
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      commiditys: []
    }
  },
  created() {
    this.throttleClick = throttle(this.clickHandle, 800, { trailing: false })
  },
  watch: {
    compProps: {
      handler(newVal) {
        this.commiditys = newVal.items.map((item) => {
          // 0 未购买，1 已购买  2 已结束
          let status = item.bought ? 1 : item.unableSell ? 0 : 2
          return {
            ...item,
            status: status
          }
        })
      },
      deep: true
    }
  },
  methods: {
    clickHandle(info, index) {
      info.commodityIndex = index
      this.$emit('action', info)
    }
  }
}
</script>
<style lang="scss" scoped>
.comp-commodity {
  width: 100%;
  display: flex;
  > div {
    width: 100%;
    font-size: 0;
  }
}
</style>
